import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {merge, of as observableOf, timer} from 'rxjs';
import {catchError, debounce, map, startWith, switchMap} from 'rxjs/operators';
import {MatTable} from '@angular/material/table';
import {FormArray} from '@angular/forms';
import {MatSnackBar} from '@angular/material/snack-bar';
import {ActivatedRoute, Router} from '@angular/router';
import {ProviderService} from './provider.service';
import {Provider} from './provider.models';
import {SearchFilters} from "../location/location.models";
import {FiltersService, LocationService} from "../location/location.service";
import {environment} from '../../environments/environment';

@Component({
    selector: 'provider',
    templateUrl: './provider.component.html',
    styleUrls: ['./provider.component.css']
})
export class ProviderComponent implements AfterViewInit, OnInit {

    readonly LOCAL_STORAGE_FILTERS_SUFFIX = 'providers-3';
    displayedColumns: string[] = ['netSuiteEmployeeFullName', 'location', 'vetSuccessTransactionProviderId', 'netSuiteEmployeeEntityId', 'updatedAt'];
    data: Provider[] = [];
    isLoadingResults = true;
    resultsLength = 0;
    pageSize = 25;
    controls: FormArray;
    filters: SearchFilters;
    showUnmappedOnly = false;

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatTable) table: MatTable<any>;
    envPrefix = environment.envPrefix;

    constructor(public route: ActivatedRoute,
                public router: Router,
                public providerService: ProviderService,
                public locationService: LocationService,
                private _snackBar: MatSnackBar,
                private filtersService: FiltersService) {
        this.initFilters();
    }

    ngOnInit() {
        this.loadLocations();
    }

    loadLocations() {
        this.locationService.findAll().subscribe(
            response => {
                this.filters.location.options = response;
            },
            error => {
                console.log(error);
            });
    }

    private initFilters() {
        this.filters = this.filtersService.getFilters(this.LOCAL_STORAGE_FILTERS_SUFFIX);
    }

    ngAfterViewInit() {
        this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));
        merge(this.sort.sortChange, this.paginator.page)
            .pipe(
                startWith({}),
                debounce(() => timer(500)),
                switchMap(() => {
                    this.isLoadingResults = true;
                    return this.providerService.find(this.sort.active, this.sort.direction, this.paginator.pageIndex, this.paginator.pageSize,
                        this.filtersService.buildSearchParam(this.filters), this.showUnmappedOnly)
                        .pipe(catchError(() => observableOf(null)));
                }),
                map(result => {
                    this.isLoadingResults = false;
                    // @ts-ignore
                    this.resultsLength = result?.totalElements;
                    const data = result?.content;
                    return data;
                }),
            )
            .subscribe(data => {
                this.data = data;
            });
    }

    updateFilter() {
        this.filtersService.saveFilters(this.filters, this.LOCAL_STORAGE_FILTERS_SUFFIX);
        this.reset();
    }

    reset() {
        this.paginator.pageIndex = 0;
        this.paginator._changePageSize(this.paginator.pageSize);
    }

    resetGrid() {
        this.filtersService.resetFilters(this.LOCAL_STORAGE_FILTERS_SUFFIX);
        this.initFilters();
        this.reset();
    }

    calculateActiveFiltersCount() {
        let result = 0;
        for (const [key, value] of Object.entries(this.filters)) {
            if (value.value) {
                result++;
            }
        }
        return result;
    }
}
